export const en = {
  nav: {
    features: "Features",
    stats: "Statistics",
    pricing: "Pricing",
    gallery: "Interface",
    contacts: "Contacts",
    about: "About us",
    faq: "FAQ",
    auth: "Authorize",
    logout: "Logout"
  },
  hero: {
    badge: "Version 2.0.1.0 • Stable Release",
    title: "Telegram PRIME",
    subtitle: "The ultimate automated combine for promotion in Telegram. Powerful mass mailings, inviting, parsing, validation checkers, and auto-responders in one click.",
    ctaStart: "Get Started Free",
    ctaPricing: "View Pricing Plans",
    ctaInterface: "Interface Demo"
  },
  stats: {
    title: "OUR COMMUNITY AND ACHIEVEMENTS!",
    onlineUsers: "Active users online",
    reviews: "Reviews on major forums",
    community: "Our forum community size",
    invites: "Total invites sent all-time",
    messages: "Total messages delivered"
  },
  features: {
    title: "POWERFUL COMBINE FEATURES",
    subtitle: "Telegram PRIME contains everything you need for comprehensive marketing and automation in Telegram",
    showAll: "Show All Features",
    hideAll: "Hide Some Features",
    items: {
      relogin: {
        title: "Session Re-login",
        desc: "Allows you to easily use accounts simultaneously by connecting from different locations."
      },
      s2td: {
        title: "Session to Tdata Converter",
        desc: "Convert your session files into TData format to run on Telegram Desktop."
      },
      td2s: {
        title: "Tdata to Session Converter",
        desc: "Convert your TData profiles into session files for use in our software."
      },
      warmup: {
        title: "AI-Powered Group Warmup",
        desc: "Run your accounts in a group, assign conversation partners & topics, and simulate active chat."
      },
      vtope: {
        title: "vTope Automation",
        desc: "Connect to the massive vTope network to earn on automated views, reactions, and subscriptions."
      },
      automsg: {
        title: "Auto-Welcome Joiners",
        desc: "Use the unique ability to intercept and pitch fresh leads as soon as they enter your chat."
      },
      autolike: {
        title: "Auto-Reactions in Channels",
        desc: "With this feature, your accounts will always be the first to place reactions on new channel posts."
      },
      autocomment: {
        title: "Auto-Comments in Channels",
        desc: "Since first comments get the most eyeballs, make sure those comments are yours!"
      },
      checker: {
        title: "Username Validator",
        desc: "Filter and validate your Telegram username lists quickly for subsequent campaigns."
      },
      unblock: {
        title: "Spamblock Removal",
        desc: "Send spamblock appeal requests with unique reasoning, extending the lifespan of your accounts."
      },
      admininvite: {
        title: "Admin-Based Inviting",
        desc: "Add members via designated group admins to prevent bans on the group itself."
      },
      reports: {
        title: "Mass Reporting Tool",
        desc: "Automate sending mass abuse reports targeting malicious Telegram groups, channels, or bots."
      },
      randomizer: {
        title: "Text Randomizer 2.0",
        desc: "Where spin-tax matches AI to achieve absolute uniqueness and high readability of messages."
      },
      stories: {
        title: "Story Manager",
        desc: "Mass publish stories on Telegram accounts, view other stories, and boost channel limits."
      },
      interceptor: {
        title: "Real-Time Message Interceptor",
        desc: "Capture and redirect incoming messages on the fly to a destination of your choice."
      },
      chatcloner: {
        title: "Group Chat Cloner",
        desc: "Found an active group? Clone it entirely, including structural design and simulated users."
      },
      webchat: {
        title: "Account Web Dashboard",
        desc: "No TData conversion needed. Open and manage your accounts in a browser interface in real time."
      },
      offerphoto: {
        title: "Offer Photo Suggestion",
        desc: "Mass suggest profile images containing customized text offers directly to targeted users."
      },
      chancloner: {
        title: "Channel Cloner",
        desc: "Clone Telegram channels dynamically (as new posts publish) or copy historical archives."
      },
      autoinvite: {
        title: "Auto-Invite Chat Joiners",
        desc: "Monitor competitor groups and automatically invite active new members to your chat."
      }
    }
  },
  details: {
    sectionTitle: "WHY TELEGRAM PRIME?",
    block1: {
      title: "A Powerhouse for Telegram Marketing",
      p1: "Join the digital promotion revolution today!",
      p2: "Deliver advertising directly to prospect devices, communicating with target users, lists of phone numbers, or group members.",
      p3: "Zero creative blocks: we support full text markdown and audio notes acting as natural voice recordings."
    },
    block2: {
      title: "Fast, Low-Cost, Massive Results",
      p1: "Telegram mass mailing is the loudest megaphone in marketing. Set up low-cost outreach using Telegram PRIME.",
      p2: "Filter your audience lists to leave only active, high-intent human profiles."
    },
    block3: {
      title: "Audience Parsing & Deep Analytics",
      p1: "Extract users from open or closed groups, post comments, or interactive chat histories.",
      p2: "Filter inactive accounts and bots based on custom activity filters and keyword matching."
    }
  },
  pricing: {
    title: "PRICING & MODULES",
    subtitle: "Choose the modules and companion services that fit your campaign goals",
    tabModules: "Core Modules",
    tabThirdParty: "Utilities",
    tabPartners: "Partner Services",
    buyCrypto: "Buy with Crypto",
    buyCard: "Buy with Card",
    askQuestion: "Ask a Question",
    eternal: "Lifetime access",
    from: "from",
    modules: {
      cloner: {
        title: "CHANNEL CLONER",
        price: "100 $",
        f1: "Lifetime license - $100",
        f2: "Real-time channel copying",
        f3: "Filter forbidden keywords",
        f4: "Replace links automatically",
        f5: "Multi-threaded execution"
      },
      interceptor: {
        title: "MESSAGE SPY & INTERCEPTOR",
        price: "100 $",
        f1: "Lifetime license - $100",
        f2: "Monitor multiple accounts simultaneously",
        f3: "Keywords lookup in real-time chats",
        f4: "Redirect hot leads to your manager bot",
        f5: "Advanced trigger phrase matching"
      },
      warmup: {
        title: "ACCOUNT DIALOGUE WARMER",
        price: "150 $",
        f1: "Lifetime license - $150",
        f2: "Fully automated profile warmups",
        f3: "AI generated dialogue scripts (ChatGPT)",
        f4: "Simulates human engagement in group chats",
        f5: "Configurable typing delays & limitations"
      }
    },
    thirdParty: {
      checker: {
        title: "Phone Number Checker",
        price: "40 $",
        desc: "Scan phone lists for Telegram presence and export user IDs, Premium status, and Usernames."
      },
      converters: {
        title: "Telegram Account Converters",
        price: "29 $",
        desc: "Convert profiles between Session, Tdata, JSON, or AuthKey formats back and forth with re-authorization."
      },
      manager: {
        title: "Web-Telegram Account Manager",
        price: "40 $",
        desc: "Manage multiple accounts via clean web dashboards, task schedulers, and unique system fingerprints."
      }
    },
    partners: {
      vps: {
        title: "Cloud VPS Servers",
        price: "14 $ / mo",
        desc: "Anonymous Windows/Linux VPS fully configured and compatible to host your TG Prime software."
      },
      redirect: {
        title: "Stealth Redirect Links",
        price: "15 $ / mo",
        desc: "Shorten and cloak urls to avoid blocklists, connect custom domains, and view live click analytics."
      },
      proxies: {
        title: "High-Quality Proxies",
        price: "7.5 $ / mo",
        desc: "Mobile, residential, and datacenter SOCKS5/HTTP proxies with rotational settings."
      }
    }
  },
  about: {
    title: "ABOUT US",
    subtitle: "The team making Telegram automation accessible and effective",
    lead: "Telegram PRIME is the official platform for selling Telegram Prime license keys and extension modules.",
    story: "We have been working in Telegram marketing for over 5 years and have combined all the necessary tools into one ecosystem. Our goal is to give arbitrageurs, SMM specialists and business owners reliable software, transparent prices and fast support. Every key is activated in the personal dashboard, and updates are released regularly and free for all users.",
    value1: {
      title: "Official keys",
      desc: "Buy Telegram Prime licenses directly through a secure personal dashboard without intermediaries or markups."
    },
    value2: {
      title: "24/7 support",
      desc: "Our team helps with activation, module setup and HWID binding via Telegram and the ticket system."
    },
    value3: {
      title: "Regular updates",
      desc: "Telegram is constantly changing, so we release updates and fixes to keep all features stable."
    },
    value4: {
      title: "Community of professionals",
      desc: "Join the users chat where people share cases, new schemes and help each other with the software."
    },
    tag: "Official reseller",
    stat1: { label: "Years on market" },
    stat2: { label: "Modules" },
    stat3: { label: "Support" },
    ctaTitle: "Still have questions?",
    ctaText: "Email us - we'll help you choose a module, activate and set it up.",
    ctaButton: "Email"
  },
  faq: {
    title: "FREQUENTLY ASKED QUESTIONS",
    subtitle: "Answers to the most common questions about buying, activating and using Telegram Prime",
    q1: "What is Telegram Prime and why do I need a key?",
    a1: "Telegram Prime is a comprehensive Telegram marketing automation tool: mass mailings, inviting, parsing, cloning and much more. A license key grants access to the personal dashboard and selected modules.",
    q2: "How do I buy a Telegram Prime key?",
    a2: "Choose the right plan or module, click Buy and pay with cryptocurrency. Once the payment is confirmed, the key will appear immediately in your personal dashboard.",
    q3: "What is the difference between demo, monthly and lifetime keys?",
    a3: "A demo key is issued for 3 days and is suitable for testing. A monthly key works for 30 days. A lifetime key provides permanent access to the base license and free updates.",
    q4: "What if I changed my computer or hardware?",
    a4: "The personal dashboard has an HWID reset feature. It allows you to transfer an activated key to a new PC. Reset is not available for demo keys.",
    q5: "Can I add modules after purchasing a key?",
    a5: "Yes, any module can be purchased separately in your personal dashboard. It will be attached to your current key and activated automatically.",
    q6: "What payment methods are available?",
    a6: "We only accept cryptocurrency. Payment details are shown at checkout in your personal dashboard.",
    q7: "Is there a refund after buying a key?",
    a7: "Digital keys and modules are non-refundable once activated. We recommend using the free demo period before purchase.",
    q8: "Where can I get help?",
    a8: "Contact us via live chat - average response time ranges from a few minutes to a couple of hours.",
    q9: "Can I buy a module separately from the core program?",
    a9: "Yes, any module can be purchased separately. You don't need to buy the base license if you only need specific functionality. The module is activated in the personal dashboard and bound to your HWID."
  },
  auth: {
    login: "Log In",
    register: "Register",
    email: "Email Address",
    password: "Password",
    username: "Username",
    confirmPassword: "Confirm Password",
    submitLogin: "Authorize",
    submitRegister: "Create Account",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    title: "Telegram Prime Panel Login",
    close: "Close",
    successMsg: "Successfully authorized!",
    welcome: "Welcome to the client control panel!",
    captchaRequired: "Please confirm you are not a robot.",
    or: "or",
    googleLogin: "Continue with Google",
    fillAllFields: "Please fill in all fields.",
    passwordMismatch: "Passwords do not match!",
    passwordWeak: "Password is too weak!",
    registerSuccess: "Registration successful! Please log in.",
    passwordStrengthWeak: "Weak",
    passwordStrengthMedium: "Medium",
    passwordStrengthStrong: "Strong",
    errorUnknown: "An error occurred",
    verifyTitle: "Confirm your email",
    verifyIntro: "We sent a 6-digit code to {email}. Enter it below to complete your registration. The account is created only after confirmation.",
    verifyLoginTitle: "Confirm sign-in",
    verifyLoginIntro: "Sign-in from a new IP address detected. We sent a code to {email}. Enter it to confirm the sign-in.",
    codeLabel: "Confirmation code",
    codePlaceholder: "6-digit code",
    confirmCode: "Confirm",
    resendCode: "Resend code",
    resendIn: "Resend in {seconds}s",
    changeEmail: "Back",
    codeRequired: "Please enter the confirmation code.",
    devCodeNotice: "Dev mode (email sending disabled), your code: {code}"
  },
  gallery: {
    title: "CONVENIENT USER INTERFACE",
    subtitle: "Preview screenshots of the Telegram PRIME control panel and settings dashboards"
  },
  footer: {
    desc: "Telegram PRIME - professional software for lead generation and automation on the Telegram platform. All rights reserved.",
    community: "Join the Community",
    support: "Technical support hours: Mon-Fri 08:00 - 20:00 (GMT+2)."
  },
  dashboard: {
    download: "Download Telegram Prime",
    title: "SYSTEM STATUS",
    modulesTitle: "COMPONENTS ARCHITECTURE",
    newsTitle: "SYSTEM LOGS",
    license: "My License",
    shop: "Modules Shop",
    changelog: "Changelog",
    referral: "Referral System",
    faq: "FAQ",
    keyInfo: "License Key Info",
    activated: "ACTIVATED",
    notActivated: "NOT ACTIVATED",
    hwidLinked: "Linked to PC",
    hwidFree: "Unlinked / Free",
    resetHwid: "Reset HWID Link",
    activatePc: "Activate on this PC",
    activeComponents: "Active Components",
    installed: "Installed",
    buy: "Buy",
    select: "Select",
    free: "Free",
    activateFree: "Activate Free",
    linkKeyFirst: "Error! Link a key first.",
    selectLicensePlan: "Select a pricing plan to generate a license key:",
    demoPeriod: "3 days",
    monthlyPeriod: "30 days",
    permanentPeriod: "Lifetime",
    payWithCrypto: "PAY WITH CRYPTO",
    transaction: "SECURE CHECKOUT",
    selectLicenseType: "Select license type",
    billingFor: "Billing node for:",
    abort: "Abort Connection",
    blocked: "BLOCKED",
    expired: "EXPIRED",
    licenseKey: "License Key",
    licenseType: "Type",
    expiresAt: "Expire",
    activeModulesCount: "Active Modules",
    active: "Active",
    lifetime: "Lifetime",
    deleteKey: "Delete Key",
    upgradeToPermanent: "Upgrade to Permanent",
    upgradeToMonthly: "Upgrade to Monthly",
    extendLicense: "Extend License",
    licenseBlockedContactSupport: "License blocked. Contact support.",
    noLicenseMessage: "You don't have an active license yet. Choose a plan to get started.",
    buyLicenseOrDemo: "Buy License / Try Demo",
    ready: "READY",
    noActiveModules: "No active modules",
    copyKey: "Copy key",
    copied: "Copied!",
    referralTitle: "Referral System",
    referralCode: "Your referral code",
    referralBalance: "Referral balance",
    referralHowItWorks: "How it works:",
    referralStep1: "Copy your personal code.",
    referralStep2: "Share the code with a friend or in an ad.",
    referralStep2Link: "Share your referral link — every visit is tracked automatically.",
    referralStep3: "The buyer gets a {percent}% discount on a paid key.",
    referralStep4: "You receive {percent}% of the purchase to your balance.",
    referralDemoInfo: "The {percent}% discount applies only to paid keys. Referral code is not available for demo keys.",
    referralLinkLabel: "Your referral link",
    referralLinkCopied: "Referral link copied!",
    referralLinkHint: "Everyone who follows this link gets your referral code automatically — no promo code needed.",
    referralClicks: "Link visits",
    faqTitle: "FAQ",
    faqEmpty: "FAQ is temporarily unavailable.",
    referralTagline: "Earn together with Telegram Prime ❤️",
    applyReferralCode: "Apply referral code",
    referralCodePlaceholder: "Enter referral code",
    referralHint: "Enter a referral code before purchase to get a discount on paid keys.",
    apply: "Apply",
    referralCodeApplied: "Referral code applied - {percent}% discount",
    referralCodeInvalid: "Invalid referral code",
    referralCodeCopied: "Referral code copied!",
    applyPromoCode: "I have a promo code",
    promoCodePlaceholder: "Enter promo code",
    promoHint: "Enter a promo code before purchase to get an additional discount. Promo and referral discounts stack.",
    promoCodeApplied: "Promo code applied - {percent}% discount",
    promoCodeInvalid: "Promo code not found or inactive",
    referralTransactions: "Referral earnings",
    referralEarning: "Earning",
    referralNoTransactions: "No referral earnings yet.",
    messages: {
      demoResetDisabled: "HWID reset is not available for demo key",
      keyNotBound: "Key is not bound to device",
      licenseExpired: "License expired. Please extend it first.",
      licenseBlocked: "License blocked",
      hwidResetSuccess: "HWID binding reset successfully!",
      tooManyRequests: "Too many requests. Please wait 24 hours.",
      hwidResetFailed: "Failed to reset HWID",
      networkError: "Network error",
      confirmDeleteKey: "Are you sure you want to delete the key? This action cannot be undone.",
      keyDeletedSuccess: "Key deleted successfully!",
      keyDeleteFailed: "Failed to delete key",
      redirectingToPayment: "Redirecting to payment...",
      upgradeRequestSent: "Upgrade request sent!",
      upgradeRequestFailed: "Failed to send upgrade request",
      extensionRequestSent: "Extension request sent!",
      extensionRequestFailed: "Failed to send extension request",
      demoModulesAdded: "Modules added to demo key for free",
      demoModulesFailed: "Failed to add modules to demo key",
      copyKeySuccess: "Key copied to clipboard",
      copyKeyFailed: "Failed to copy key"
    }
  },
  license: {
    success: {
      demo_activated: "Demo key activated successfully"
    }
  },
  cabinetFaq: {
    subtitle: "Frequently asked questions about licenses and modules",
    q1: "How do I activate the purchased key?",
    a1: "After payment, the key will appear in your personal dashboard on the 'My License' tab. Click 'Activate on this PC' to bind the HWID.",
    q2: "What is HWID and why is it needed?",
    a2: "HWID is a unique identifier of your computer. It protects the key from being transferred to third parties. Binding happens automatically upon activation.",
    q3: "How do I reset HWID if I changed my computer?",
    a3: "In the dashboard on the 'My License' tab, click 'Reset HWID Link'. Reset is available no more than once per 24 hours. Not available for demo keys.",
    q4: "How do I buy an additional module?",
    a4: "Go to the 'Modules Shop' tab, select the module and click 'Buy'. After payment, the module will automatically be bound to your key.",
    q5: "Can I use one key on multiple PCs?",
    a5: "No, one key can only be activated on one PC at a time. Use HWID reset to transfer it.",
    q6: "Where can I download Telegram Prime?",
    a6: "The download link is at the top of the dashboard - the 'Download Telegram Prime' button.",
    q7: "How do I apply a referral code?",
    a7: "In the dashboard there is a 'Referral System' block. Enter the code before purchasing a paid key and the discount will be applied automatically.",
    q8: "What if my license has expired?",
    a8: "On the 'My License' tab, select 'Extend License' or 'Upgrade to Permanent'. Access will be restored after payment.",
    q9: "What if the key is blocked?",
    a9: "If you see the 'Blocked' status, contact technical support. The block may be related to a violation of usage rules.",
    q10: "Why didn't the module appear after payment?",
    a10: "Check the payment status in the dashboard. If funds were deducted but the module was not added, contact support with the transaction number.",
    supportTitle: "Didn't find an answer?",
    supportText: "Contact us via live chat - we'll help you with activation, modules and payment.",
    emailBtn: "Email",
    telegramBtn: "Telegram"
  },
  modules: {
    module_1: {
      name: "Chat Cloner",
      features: [
        "Lifetime access - 345 $",
        "Chat history collection",
        "Accounts preparation",
        "Message editor, edit history as you need",
        "Post history at intervals or as in original",
        "Get a copy of competitor's group",
        "No refunds"
      ]
    },
    module_2: {
      name: "Reporter",
      features: [
        "Lifetime access - 175 $",
        "Ability to block competitor channel",
        "Ability to block competitor group",
        "Ability to block TG bot",
        "Complaints through inviting to chats",
        "Multi-threaded work",
        "No refunds"
      ]
    },
    module_3: {
      name: "Channel Cloner",
      features: [
        "Lifetime access - 105 $",
        "Autonomous channel filling",
        "Replace keywords and links",
        "Clone old posts",
        "Exclude unwanted content and add your own",
        "Multi-threaded work for quick results",
        "No refunds"
      ]
    },
    module_4: {
      name: "Message Interceptor",
      features: [
        "Lifetime access - 100 $",
        "Monitors everything happening on the account",
        "Real-time keyword search in chats",
        "Multi-threaded work",
        "Forward requests anywhere you need (channel, bot, or account)",
        "Use keywords or phrases",
        "No refunds"
      ]
    },
    module_5: {
      name: "Account Warmer",
      features: [
        "Lifetime access - 150 $",
        "Fully automated module operation",
        "Warm-up through many automatically executed actions",
        "Manage the number of tasks being executed",
        "Text uniquification through AI",
        "Multi-threaded work with configurable delays between actions",
        "No refunds"
      ]
    }
  },
  news: {
    error: "Failed to load updates",
    noUpdates: "No updates available",
    loading: "Loading updates...",
    latestUpdate: "LATEST UPDATE",
    version: "VERSION",
    update: "UPDATE"
  }
};
